import React from "react";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
} from "chart.js";
import { Pie, Bar } from "react-chartjs-2";

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title
);

// Named export for the Pie chart
export const PieGraph = ({ data, options }) => {
  const defaultOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom',
      },
      title: {
        display: false,
      },
    },
    maintainAspectRatio: false,
  };

  return (
    <div style={{ height: '300px', width: '100%', display: 'flex', justifyContent: 'center' }}>
      <Pie data={data} options={options || defaultOptions} />
    </div>
  );
};

// Named export for the Bar chart
export const BarGraph = ({ data, options }) => {
  const defaultOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
      },
      title: {
        display: false,
      },
    },
    scales: {
      x: {
        stacked: true,
        grid: {
          display: false
        }
      },
      y: {
        stacked: true,
        beginAtZero: true,
        grid: {
          color: 'rgba(0,0,0,0.05)'
        }
      },
    },
    barThickness: 50,
    categoryPercentage: 0.8,
    barPercentage: 0.9,
  };

  return (
    <div style={{ height: '350px', width: '100%' }}>
      <Bar data={data} options={options || defaultOptions} />
    </div>
  );
};